import http from '@/services/http'
import entriesList from './generic/entries-list'

export const state = () => ({
  ...entriesList.getState(),
})

export const mutations = {
  ...entriesList.getMutations(),
}

export const actions = {
  ...entriesList.getActions({
    getQueryUrl({ params }) {
      let url = '/admin/startup-applications'
      const querystring = http.paramsToQuerystring(params)
      if (querystring) {
        url += `?${querystring}`
      }
      return url
    },
    queryIsPaginated: true,
  }),
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
